/* eslint-disable max-len */
import React from 'react'

import { string } from 'prop-types'

function PriceRange(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.0003 16.75C15.4144 16.7501 15.7503 17.0858 15.7503 17.5C15.7503 17.9142 15.4144 18.2499 15.0003 18.25H5.00028C4.58607 18.25 4.25028 17.9142 4.25028 17.5C4.25028 17.0858 4.58607 16.75 5.00028 16.75H15.0003ZM10.0003 5.91698C10.2401 5.91709 10.4657 6.03165 10.6067 6.22558L13.6419 10.3994L16.4847 9.68944C16.7537 9.62217 17.0382 9.70899 17.2239 9.91503C17.4093 10.121 17.4659 10.4124 17.3714 10.6728L15.7044 15.2568C15.5965 15.5527 15.3153 15.7499 15.0003 15.75H5.00028C4.68513 15.7499 4.40308 15.5529 4.2952 15.2568L2.62821 10.6728C2.5337 10.4124 2.59127 10.1209 2.77665 9.91503C2.96227 9.70919 3.24601 9.62235 3.51493 9.68944L6.3577 10.3994L9.39384 6.22558L9.45048 6.15722C9.59142 6.00527 9.79038 5.91704 10.0003 5.91698ZM7.27274 11.6914C7.09284 11.9384 6.78111 12.0516 6.48466 11.9775L4.51981 11.4863L5.5247 14.25H14.4749L15.4798 11.4863L13.5149 11.9775C13.2185 12.0515 12.9066 11.9385 12.7268 11.6914L9.9993 7.9414L7.27274 11.6914ZM10.0003 1.74999C10.42 1.75011 10.8236 1.91703 11.1204 2.21386C11.417 2.51068 11.5842 2.91337 11.5843 3.333C11.5843 3.75282 11.4172 4.15621 11.1204 4.45312C10.8236 4.74994 10.42 4.91686 10.0003 4.91698C9.58066 4.9169 9.17796 4.74973 8.88114 4.45312C8.58421 4.15618 8.41727 3.75293 8.41727 3.333C8.41736 2.91319 8.58429 2.51071 8.88114 2.21386C9.17797 1.91715 9.58058 1.75008 10.0003 1.74999ZM10.0003 3.24999C9.97841 3.25008 9.95722 3.259 9.94169 3.27441C9.92614 3.28996 9.91736 3.31102 9.91727 3.333C9.91727 3.3551 9.92606 3.37694 9.94169 3.39257C9.9572 3.40788 9.97848 3.4169 10.0003 3.41698C10.0222 3.41686 10.0443 3.40809 10.0599 3.39257C10.0753 3.37696 10.0843 3.35499 10.0843 3.333C10.0842 3.3112 10.0752 3.28992 10.0599 3.27441C10.0443 3.25888 10.0222 3.25011 10.0003 3.24999Z"
        fill="#35424F"
      />
    </svg>
  )
}

PriceRange.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default PriceRange
